/**
 * Product Add-ons Positioning Script
 * Moves the product-add-ons section below the variant selector when page loads
 */

(function() {
  'use strict';
  
  function repositionAddOnsSection() {
    // Find the product add-ons section
    const addOnsSection = document.querySelector('.product-add-ons');
    console.log('Found add-ons section:', addOnsSection);
    if (!addOnsSection) {
      console.log('Product add-ons section not found');
      return;
    }
    
    // Initially hide the section
    addOnsSection.style.opacity = '0';
    
    // Find the variant selector container
    const variantContainer = document.querySelector('.xo-product-info-content__variant--pd');
    
    if (!variantContainer) {
      console.log('Variant container not found');
      return;
    }
    
    // Store original parent for reference
    const originalParent = addOnsSection.parentElement;
    
    // Insert the add-ons section after the variant container
    if (variantContainer.parentElement) {
      variantContainer.parentElement.insertBefore(
        addOnsSection,
        variantContainer.nextSibling
      );
      
      // Add positioned class and fade in
      setTimeout(function() {
        addOnsSection.classList.add('positioned');
        addOnsSection.style.opacity = '1';
      }, 50);
      
      console.log('Product add-ons section repositioned successfully');
    }
  }
  
  // Run on DOM content loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repositionAddOnsSection);
  } else {
    // DOM already loaded
    repositionAddOnsSection();
  }
  
  // Also run after a short delay to handle dynamic content
  window.addEventListener('load', function() {
    setTimeout(repositionAddOnsSection, 100);
  });
  
})();
